import { useRepositoryQuery } from '@mews-commander/data-access';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { isBookableService } from '@mews-commander/legacy-entities/src/ducks/servicesNew';
import { sortOrderableEntity } from '@mews-commander/legacy-entities/src/utils/orderableEntities';

export const useReservableServices = () => {
    const currentEnterpriseId = useCurrentEnterpriseId();

    return useRepositoryQuery(
        'services',
        'getAll',
        {
            enterpriseIds: [currentEnterpriseId],
        },

        {
            select: (data) => data.services.filter(isBookableService).sort(sortOrderableEntity),
        }
    );
};
